import { defineMessages } from "react-intl"

const messages = defineMessages({
  favourites: {
    id: "favourites.favourites",
    defaultMessage: "Favourites"
  },
  noSets: {
    id: "sets.no-sets",
    defaultMessage:
      "You have no other sets yet. Create your first one in the area above, or just keep using favourites to keep it simple."
  },
  confirmDelete: {
    id: "sets.confirm-delete",
    defaultMessage: "Are your sure you want to delete this set?"
  },
  noSetsAdded: {
    id: "sets.no-sets-added",
    defaultMessage: "You haven't added any sets/favourites yet."
  },
  loadMoreItems: {
    id: "sets.load-more-items",
    defaultMessage: "Load More Items"
  },
  backToAllSets: {
    id: "sets.back-to-all-sets",
    defaultMessage: "Back to all Sets"
  },
  selectSet: {
    id: "sets.select-set",
    defaultMessage: "Select Set"
  },
  sets: {
    id: "sets.sets",
    defaultMessage: "Sets"
  },
  allSets: {
    id: "sets.all-sets",
    defaultMessage: "All Sets"
  },
  otherSets: {
    id: "sets.other-sets",
    defaultMessage: "Other Sets"
  },
  createNewSet: {
    id: "sets.create-new-set",
    defaultMessage: "Create new set"
  },
  create: {
    id: "sets.create",
    defaultMessage: "Create"
  },
  deleteThisSet: {
    id: "sets.delete-this-set",
    defaultMessage: "Delete this set"
  },
  makeSetPrivate: {
    id: "sets.make-set-private",
    defaultMessage: "Make this set private"
  },
  makeSetPublic: {
    id: "sets.make-set-public",
    defaultMessage: "Make this set publicly visible"
  },
  privateSet: {
    id: "sets.private-set",
    defaultMessage: "Private Set"
  },
  publicSet: {
    id: "sets.public-set",
    defaultMessage: "Public Set"
  },
  editSetName: {
    id: "sets.edit-set-name",
    defaultMessage: "Edit Set Name"
  }
})

export default messages



// WEBPACK FOOTER //
// ./webapp/messages/sets.js